import { createAsyncAction } from 'typesafe-actions'
import { AuthResponseDto } from '@sparling/financial-common'

export const {
  request: loginRequest,
  success: loginSuccess,
  failure: loginFailure,
} = createAsyncAction('LOGIN_REQUEST', 'LOGIN_SUCCESS', 'LOGIN_FAILURE')<
  { username: string; password: string },
  AuthResponseDto,
  Error | null
>()

export const {
  request: login2FARequest,
  success: login2FASuccess,
  failure: login2FAFailure,
} = createAsyncAction('LOGIN_2FA_REQUEST', 'LOGIN_2FA_SUCCESS', 'LOGIN_2FA_FAILURE')<
  { twoFaCode: string },
  AuthResponseDto,
  Error | null
>()

export const {
  request: logoutRequest,
  success: logoutSuccess,
  failure: logoutFailure,
} = createAsyncAction('LOGOUT_REQUEST', 'LOGOUT_SUCCESS', 'LOGOUT_FAILURE')<
  void,
  { code: number; status: string; message: string },
  Error | null
>()
